export const WHATSAPP_NUMBER = "5562981648148";
export const WHATSAPP_DISPLAY = "+55 62 98164-8148";
export const INSTAGRAM_URL = "https://instagram.com/draxfilmes";
export const INSTAGRAM_HANDLE = "@draxfilmes";

export const wa = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MSG = {
    general: "Olá! Vim pelo site da Drax Filmes e quero saber mais sobre os planos.",
    trial: "Olá! Quero solicitar meu teste grátis da Drax Filmes.",
    catalog:
        "Olá! Quero receber a lista completa de filmes, séries e canais da Drax Filmes.",
    monthly: "Olá! Quero assinar o Plano Mensal da Drax Filmes.",
    quarterly: "Olá! Quero assinar o Plano Trimestral da Drax Filmes.",
    semestral: "Olá! Quero assinar o Plano Semestral da Drax Filmes.",
    yearly: "Olá! Quero assinar o Plano Anual da Drax Filmes.",
};

export const scrollToSection = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

const p = (id) => `https://image.tmdb.org/t/p/w500/${id}.jpg`;
const b = (id) => `https://image.tmdb.org/t/p/w1280/${id}.jpg`;
const u = (id) =>
    `https://images.unsplash.com/${id}?q=80&w=900&auto=format&fit=crop`;

export const POSTERS = {
    endgame: p("or06FN3Dka5tukK1e9sl16pB3iy"),
    spiderman: p("1g0dhYtq4irTY1GPXvft6k4YLjm"),
    batman: p("74xTEgt7R36Fpooo50r9T25onhq"),
    panther: p("sv1xJUazXeYqALzczSZ3O6nkH75"),
    guardians: p("r2J02Z2OpNTctfOSN1Ydgii51I3"),
    flash: p("rktDFPbfHfUbArZ6OOOKsXcv0Bm"),
    avatar: p("t6HIqrRAclMCA60NsSmeqe9RmNV"),
    johnwick: p("vZloFAK7NmvMGKE7VkF5UHaz0I"),
    darkknight: p("qJ2tW6WMUDux911r6m7haRef0WH"),
    topgun: p("62HCnUTziyWcpDaBO2i1DX17ljH"),
    breakingbad: p("ggFHVNu6YYI5L9pCfOacjizRGt"),
    lastofus: p("uKvVjHNqB5VmOrdxqAt2F7J78ED"),
    lacasadepapel: p("reEMJA1uzscCbkpeRJeTT2bjqUp"),
    got: p("u3bZgnGQ9T01sWNhyveQz0wH0Hl"),
    round6: p("dDlEmu3EZ0Pgg93K2SVNLCjCSvE"),
    peaky: p("vUUqzWa2LnHIVqkaKVlVGkVcZIW"),
};

export const BACKDROPS = {
    endgame: b("7RyHsO4yDXtBv1zUU3mTpHeQ0d5"),
    spiderman: b("14QbnygCuTO0vl7CAFmPf1fgZfV"),
    batman: b("b0PlSFdDwbyK0cf5RxwDpaOJQvQ"),
};

export const SCENES = {
    theater: u("photo-1536440136628-849c177e76a1"),
    projector: u("photo-1489599849927-2ee91cede3ba"),
    crowd: u("photo-1517604931442-7e0c8ed2963c"),
    stadium: u("photo-1599158150601-1417ebbaafdd"),
    stadiumHigh: u("photo-1489944440615-453fc2b6a9a9"),
    onAir: u("photo-1663841366340-c0fee65c6a11"),
    soccerField: u("photo-1629217855633-79a6925d6c47"),
};

export const MARQUEE_ITEMS = [
    "Netflix",
    "HBO Max",
    "Disney+",
    "Prime Video",
    "Marvel",
    "DC",
    "Globoplay",
    "Paramount+",
    "Apple TV+",
    "Premiere",
    "Combate",
    "ESPN",
    "Telecine",
    "DAZN",
];

export const CATALOG_TABS = [
    {
        id: "alta",
        label: "Em alta",
        title: "Os lançamentos que todo mundo está comentando",
        desc: "Do cinema direto para a sua tela: os filmes mais assistidos do momento, dublados e em 4K.",
        posters: [
            { img: POSTERS.avatar, title: "Avatar: O Caminho da Água", rating: "7.5" },
            { img: POSTERS.johnwick, title: "John Wick 4: Baba Yaga", rating: "7.7" },
            { img: POSTERS.topgun, title: "Top Gun: Maverick", rating: "8.2" },
            { img: POSTERS.guardians, title: "Guardiões da Galáxia Vol. 3", rating: "7.9" },
            { img: POSTERS.panther, title: "Pantera Negra: Wakanda Para Sempre", rating: "6.7" },
            { img: POSTERS.flash, title: "The Flash", rating: "6.7" },
        ],
    },
    {
        id: "herois",
        label: "Marvel & DC",
        title: "Heróis, vilões e multiversos completos",
        desc: "Todo o universo Marvel e DC reunido: sagas completas, em ordem, para assistir do começo ao fim.",
        posters: [
            { img: POSTERS.endgame, title: "Vingadores: Ultimato", rating: "8.4" },
            { img: POSTERS.spiderman, title: "Homem-Aranha: Sem Volta para Casa", rating: "8.2" },
            { img: POSTERS.batman, title: "The Batman", rating: "7.8" },
            { img: POSTERS.darkknight, title: "Batman: O Cavaleiro das Trevas", rating: "9.0" },
            { img: POSTERS.guardians, title: "Guardiões da Galáxia Vol. 3", rating: "7.9" },
            { img: POSTERS.panther, title: "Pantera Negra: Wakanda Para Sempre", rating: "6.7" },
        ],
    },
    {
        id: "series",
        label: "Séries",
        title: "Temporadas completas para maratonar",
        desc: "As séries mais premiadas e comentadas, com episódios novos adicionados todos os dias.",
        posters: [
            { img: POSTERS.breakingbad, title: "Breaking Bad", rating: "9.5" },
            { img: POSTERS.lastofus, title: "The Last of Us", rating: "8.8" },
            { img: POSTERS.got, title: "Game of Thrones", rating: "9.2" },
            { img: POSTERS.round6, title: "Round 6", rating: "8.0" },
            { img: POSTERS.lacasadepapel, title: "La Casa de Papel", rating: "8.2" },
            { img: POSTERS.peaky, title: "Peaky Blinders", rating: "8.8" },
        ],
    },
    {
        id: "esportes",
        label: "Esportes & Canais",
        title: "O jogo do seu time, ao vivo e sem travar",
        desc: "Brasileirão, Libertadores, Champions, UFC, F1 e centenas de canais fechados em HD e 4K.",
        posters: [
            { img: SCENES.stadium, title: "Futebol ao vivo", live: true },
            { img: SCENES.stadiumHigh, title: "UFC e lutas", live: true },
            { img: SCENES.onAir, title: "Canais fechados", live: true },
            { img: SCENES.soccerField, title: "Premiere e Combate", live: true },
            { img: SCENES.crowd, title: "Cinema e estreias", live: false },
            { img: SCENES.projector, title: "Clássicos em HD", live: false },
        ],
    },
];

export const PLANS = [
    {
        id: "mensal",
        name: "Plano Mensal",
        badge: "Início rápido",
        price: "R$ 25,00",
        period: "/mês",
        popular: false,
        message: WA_MSG.monthly,
        features: [
            "1 tela simultânea",
            "Catálogo completo de filmes e séries",
            "Qualidade SD, HD, FHD e 4K",
            "Guia de programação (EPG)",
            "Suporte pelo WhatsApp",
        ],
    },
    {
        id: "trimestral",
        name: "Plano Trimestral",
        badge: "Sai a R$ 20/mês",
        price: "R$ 60,00",
        period: "/3 meses",
        perMonth: "R$ 20,00/mês",
        popular: false,
        message: WA_MSG.quarterly,
        features: [
            "2 telas simultâneas",
            "Catálogo completo de filmes e séries",
            "Qualidade SD, HD, FHD e 4K",
            "Guia de programação (EPG)",
            "Prioridade no suporte",
            "Ajuda gratuita na instalação",
        ],
    },
    {
        id: "semestral",
        name: "Plano Semestral",
        badge: "Mais vendido",
        price: "R$ 100,00",
        period: "/6 meses",
        perMonth: "R$ 16,67/mês",
        popular: true,
        message: WA_MSG.semestral,
        features: [
            "2 telas simultâneas",
            "Catálogo completo de filmes e séries",
            "Qualidade SD, HD, FHD e 4K",
            "Guia de programação (EPG)",
            "Prioridade no suporte",
            "Ajuda gratuita na instalação",
        ],
    },
    {
        id: "anual",
        name: "Plano Anual",
        badge: "Melhor custo-benefício",
        price: "R$ 180,00",
        period: "/ano",
        perMonth: "R$ 15,00/mês",
        popular: false,
        message: WA_MSG.yearly,
        features: [
            "3 telas simultâneas",
            "Catálogo completo de filmes e séries",
            "Qualidade SD, HD, FHD e 4K",
            "Servidores VIP ultra rápidos",
            "Suporte prioritário",
            "Ajuda gratuita na instalação",
        ],
    },
];

export const TESTIMONIALS = [
    {
        name: "Carlos M.",
        city: "Goiânia",
        quote:
            "Instalação foi super rápida, em poucos minutos já estava assistindo tudo na minha Samsung. Recomendo demais.",
    },
    {
        name: "Renata A.",
        city: "Aparecida de Goiânia",
        quote:
            "Não travou em nenhum jogo do Brasileirão até hoje. E as séries aparecem no dia seguinte ao episódio novo.",
    },
    {
        name: "Marcos V.",
        city: "Goiás",
        quote:
            "Cancelei os streamings caros e agora pago uma fração por algo muito mais completo. Suporte responde na hora.",
    },
];

export const FAQ_ITEMS = [
    {
        q: "O que é a Drax Filmes?",
        a: "É um serviço de TV por assinatura digital que reúne canais fechados, filmes e séries de todas as plataformas em um único acesso, transmitidos pela internet.",
    },
    {
        q: "Em quais aparelhos funciona?",
        a: "Funciona em Smart TVs (Samsung, LG e outras com Android TV), Fire TV, TV Box, celulares, tablets e computador. Na instalação, a gente te guia passo a passo pelo WhatsApp.",
    },
    {
        q: "Como funciona o teste grátis?",
        a: "É simples: chame no WhatsApp, pede seu teste e receba um acesso gratuito para testar a qualidade e o catálogo antes de assinar qualquer plano.",
    },
    {
        q: "Preciso de internet muito rápida?",
        a: "Não. O serviço funciona bem a partir de 10 mega de internet. Para aproveitar a qualidade 4K, recomendamos 25 mega ou mais.",
    },
    {
        q: "Quais são as formas de pagamento?",
        a: "As formas de pagamento são combinadas direto no atendimento pelo WhatsApp, do jeito mais prático para você.",
    },
    {
        q: "Posso assistir em mais de uma tela?",
        a: "Sim. O número de telas simultâneas depende do plano escolhido: mensal, trimestral, semestral ou anual.",
    },
];
